__turbopack_context__.v({
  "media": "style-module-scss-module__Cq2S8W__media",
  "mediaWrapper": "style-module-scss-module__Cq2S8W__mediaWrapper",
  "postRow": "style-module-scss-module__Cq2S8W__postRow",
  "timeToRead": "style-module-scss-module__Cq2S8W__timeToRead",
  "title": "style-module-scss-module__Cq2S8W__title",
});
